// extracted by mini-css-extract-plugin
module.exports = {"subSection":"Situation_subSection__2-CEF","subSectionTitle":"Situation_subSectionTitle__35mM9","subSectionContent":"Situation_subSectionContent__16-c_"};